import { memo } from 'react';
import { NavLink } from 'react-router-dom';

import { logoInner } from 'components/Header/constants';
import { ROUTES_PATHS } from 'routes/constants';
import { LogoIcn } from 'utils/icons';

const HeaderLogo = () =>
  <NavLink to={ROUTES_PATHS.home} className={logoInner}><LogoIcn />track</NavLink>;

export default memo(HeaderLogo);
